<script>
  import { onMount } from "svelte";
  import { detailOnly } from "./store";

  import Detail from "./Detail.svelte";
  import Loader from "./Loader.svelte";

  /**
   * @typedef {Object} Props
   * @property {any} [rolls]
   * @property {any} [categories]
   * @property {string} [searchterm]
   * @property {number} [limit]
   */

  /** @type {Props} */
  let {
    rolls = $bindable([]),
    categories = $bindable([]),
    searchterm = $bindable(""),
    limit = 3,
  } = $props();

  let select = $state();
  let detail = $state();
  let loading = $state(1);

  //  const showModal = () => modal.set(bind(Popup, {}))

  function getBaseUrl() {
    let app = document.getElementById("app");
    return app.getAttribute("data-base-url");
  }

  function l(str) {
    return _translations.hasOwnProperty(str) ? _translations[str] : str;
  }

  console.log("app fired");
  async function updateRolls(data, cats) {
    let r = data;
    let latestCat = cats.filter((c) => {
      return c.category.indexOf("latest") == 0;
    });
    if (latestCat.length) {
      let catId = latestCat[0].id;
      let length = r.length > limit ? limit : r.length;
      let i = 0;
      for (; i < length; i++) {
        r[i].categories.push({ id: catId });
      }
    }
    console.log(r);
    return r;
  }

  function setSelect(cats) {
    let latestCat = cats.filter((c) => {
      return c.category.indexOf("latest") == 0;
    });
    let o = "";
    if (latestCat.length) {
      o = latestCat[0];
    }
    return o;
  }
  // app start - get the jsons
  onMount(async () => {
    console.log("onMounted");
    const ro = await fetch(getBaseUrl() + "rolls/");
    const ca = await fetch(getBaseUrl() + "categories/rolls/");
    categories = await ca.json();
    rolls = await updateRolls(await ro.json(), categories);
    console.log(ro);
    select = setSelect(categories);
    loading = 0;
  });

  function onkeyup(e) {
    filtered = rolls.filter(function (s) {
      return s.search_content.indexOf(searchterm.toLowerCase()) > -1;
    });
  }

  function onkeydown(e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
    }
  }

  function filterOnChange() {
    let out = rolls;
    // console.log(select);
    if (select.id == "1132") {
      console.log("alle");
      out = rolls;
      // console.log(filtered)
    } else {
      out = rolls.filter((r) => {
        let cats = r.categories;
        let f = cats.filter((c) => {
          return select.id == c.id;
        });
        if (f.length) return r;
      });
    }

    return out;
  }
  function getSummary() {
    // console.log(select);
    let obj = categories.filter((c) => {
      return c.id == select;
    });
    // console.log(obj);
    return obj.length ? obj[0].summary : "";
  }

  function openItem(item) {
    detailOnly.set(true);
    console.log($detailOnly);

    detail = item;
  }
  function getPlayer(item) {
    let data = item.hasOwnProperty("gnd_data") ? item.gnd_data : null;
    // console.log("get player")
    // console.log(data);
    let player = "Anonymus";
    if (data) {
      let playerObj = data.c.filter((d) => {
        return d.n == "player";
      });
      let newPlayerObj = data.c.filter((d) => {
        return d.n == "player_new";
      });

      if (playerObj.length && playerObj[0].c !== "") player = playerObj[0].c;
      if (newPlayerObj.length && newPlayerObj[0].c !== "") player = newPlayerObj[0].o;
    }
    return player;
  }
  function strip_tags(str) {
    return str.replace(/(<([^>]+)>)/gi, "");
  }
  // let rollsreq = fetch(getBaseUrl() + "rolls/");
  // let catreq = fetch(getBaseUrl() + "categories/rolls/");
  let filtered = $derived(typeof select === "undefined" ? rolls : filterOnChange());
  let summary = $derived(select ? select.summary : "");
  let showsearch = $derived(
    typeof select === "undefined" || select.category.indexOf("latest") > -1
      ? false
      : true,
  );
</script>

<div class="inner">
  {#if !$detailOnly}
    {#if loading}
      <Loader message={l("loading")} />
    {:else}
      <div class="overview">
        <form>
          <div class="form-group select-list">
            <label for="filter-categories">{l("show")}</label>
            <select id="filter-categories" bind:value={select}>
              <!-- <option value="">--</option> -->
              {#each categories as category, i}
                <option value={category}>{category.title}</option>
              {/each}
            </select>
            {#if summary}
              <div class="filter-summary">
                {@html summary}
              </div>
            {/if}
          </div>
          {#if showsearch}
            <div class="form-group text-input">
              <label for="search-term" class="sr-only">{l("advanced_search")}</label>
              <input
                type="text"
                name="search-term"
                placeholder={l("advanced_search")}
                bind:value={searchterm}
                id="search-term"
                {onkeyup}
                {onkeydown}
              />
            </div>
          {/if}
        </form>
        {#if filtered.length}
          <div class="roll-list">
            <ul>
              {#each filtered as item, index}
                <li data-id={item.id} onclick={openItem(item)}>
                  <div class="col-1">
                    <span class="roll-id">{item.roll_id.c}</span>
                  </div>
                  <div class="col-2">
                    <span class="composer">{item.composer.c}</span>
                    <span class="title">{item.title}</span>
                    <span class="player">{@html strip_tags(getPlayer(item))}</span>
                  </div>
                </li>
              {/each}
            </ul>
          </div>
        {/if}
      </div>
    {/if}
  {:else}
    <Detail {detail} />
  {/if}
</div>
